module.exports = __webpack_public_path__ + "img/bg-section-04.06ddc92a.svg";